export default "__VITE_ASSET__Dam9MjJ5__"